import { render, staticRenderFns } from "./RoomControls.vue?vue&type=template&id=56f50466&scoped=true&"
import script from "./RoomControls.vue?vue&type=script&lang=js&"
export * from "./RoomControls.vue?vue&type=script&lang=js&"
import style0 from "./RoomControls.vue?vue&type=style&index=0&id=56f50466&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f50466",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56f50466')) {
      api.createRecord('56f50466', component.options)
    } else {
      api.reload('56f50466', component.options)
    }
    module.hot.accept("./RoomControls.vue?vue&type=template&id=56f50466&scoped=true&", function () {
      api.rerender('56f50466', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Room/Controls/RoomControls.vue"
export default component.exports